import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./App.css";
import "./WelcomePage.css";
import AppFooter from "./AppFooter";
import { clearToken } from "./authStorage";

function WorkspaceTermsPage() {
  const [contactOpen, setContactOpen] = useState(false);

  const handleLogout = () => {
    clearToken();
    window.location.replace("/login");
  };

  return (
    <div className="app-container welcome-page">
      <main className="welcome-workspace">
        <aside className="welcome-sidebar">
          <div className="welcome-sidebar-brand">
            <Link to="/welcome" className="welcome-sidebar-brand-link">
              <span className="welcome-sidebar-brand-mark" aria-hidden="true" />
              <span className="welcome-sidebar-brand-text">StatementIQ</span>
            </Link>
          </div>

          <div className="welcome-sidebar-nav">
            <div className="welcome-sidebar-group">
              <p className="welcome-sidebar-title">Workspace</p>
              <Link to="/welcome" className="welcome-sidebar-link">
                Convert Statements
              </Link>
            </div>

            <div className="welcome-sidebar-group">
              <p className="welcome-sidebar-title">Help &amp; Support</p>
              <Link to="/account" className="welcome-sidebar-link">
                Account
              </Link>
              <Link to="/workspace-faq" className="welcome-sidebar-link">
                FAQ
              </Link>
            </div>

            <div className="welcome-sidebar-group">
              <p className="welcome-sidebar-title">Legal</p>
              <Link to="/privacy" className="welcome-sidebar-link">
                Privacy Policy
              </Link>
              <Link to="/terms" className="welcome-sidebar-link active">
                Terms of Service
              </Link>
            </div>
          </div>

          <div className="welcome-sidebar-support-card">
            <strong>Need help?</strong>
            <p>Our support team is here to assist you.</p>
            <button
              type="button"
              className="welcome-sidebar-support-button"
              onClick={() => setContactOpen(true)}
            >
              Contact Support
            </button>
          </div>
          <button
            type="button"
            className="welcome-sidebar-link welcome-sidebar-button welcome-sidebar-logout"
            onClick={handleLogout}
          >
            Logout
          </button>
        </aside>

        <section className="welcome-content">
          <div className="welcome-body-grid">
            <div className="welcome-main-panel workspace-scroll-panel">
              <div className="welcome-heading-row">
                <div>
                  <h1>Terms of Service</h1>
                  <p className="welcome-subtitle workspace-account-subtitle">
                    The terms governing your use of StatementIQ and the bank statement conversion service.
                  </p>
                </div>
              </div>

              <div className="workspace-legal-meta">
                <p>These terms govern your use of StatementIQ, operated by MinervaCredit, Inc.</p>
              </div>

              <div className="workspace-legal-content">
                <h2>1. Acceptance</h2>
                <p>
                  By accessing or using StatementIQ, you agree to these Terms of Service. If you do not agree, you must not use
                  the service.
                </p>

                <h2>2. Service Description</h2>
                <p>StatementIQ converts bank statement PDFs into structured Excel output for review and analysis.</p>
                <p>The service may include optional checks and categorized transaction outputs based on available data.</p>

                <h2>3. Eligibility and Account Security</h2>
                <p>
                  You are responsible for maintaining the confidentiality of your account credentials and for all activity under
                  your account.
                </p>

                <h2>4. Acceptable Use</h2>
                <ul>
                  <li>Upload only documents you are authorized to use.</li>
                  <li>Do not upload malicious, unlawful, or misleading content.</li>
                  <li>Do not attempt to disrupt, reverse-engineer, or misuse the platform.</li>
                  <li>Provide only properly redacted samples where requested.</li>
                </ul>

                <h2>5. Output Verification</h2>
                <p>
                  You are responsible for reviewing and validating all generated outputs before relying on them for financial,
                  operational, or compliance decisions.
                </p>

                <h2>6. Disclaimers</h2>
                <p>
                  The service is provided on an &quot;as is&quot; and &quot;as available&quot; basis. We do not warrant uninterrupted
                  availability, complete accuracy, or fitness for a particular purpose.
                </p>

                <h2>7. Privacy</h2>
                <p>
                  Use of the service is also governed by our <Link to="/privacy">Privacy Policy</Link>.
                </p>

                <h2>8. Service Changes and Availability</h2>
                <p>
                  We may update, suspend, or discontinue features at any time for maintenance, security, legal compliance, or
                  product improvements.
                </p>

                <h2>9. Contact</h2>
                <p>
                  For questions about these terms, contact <a href="mailto:support@statementiq.co.uk">support@statementiq.co.uk</a>.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      {contactOpen && (
        <div className="welcome-tips-popup-overlay" onClick={() => setContactOpen(false)}>
          <div className="welcome-tips-popup" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="welcome-tips-close"
              aria-label="Close contact popup"
              onClick={() => setContactOpen(false)}
            >
              ×
            </button>
            <div className="welcome-tips-header">
              <h2>Contact Us</h2>
            </div>
            <div className="welcome-contact-body">
              <p>If you need help with bank statement uploads, conversion issues, or account access, please contact our support team.</p>
              <p>Include your name, company, and a short summary of the issue so we can help quickly.</p>
              <p><a href="mailto:support@statementiq.co.uk">support@statementiq.co.uk</a></p>
            </div>
          </div>
        </div>
      )}

      <AppFooter />
    </div>
  );
}

export default WorkspaceTermsPage;
